/* eslint-disable */
document.addEventListener('DOMContentLoaded', function() {
  const faqRows = document.querySelectorAll('.wp-block-app-faq-row');

  faqRows.forEach(function(faqRow, index) {
    faqRow.addEventListener('click', function() {
      const isOi = faqRow.classList.contains('is-pinned');

      document.querySelectorAll('.wp-block-app-faq-row').forEach(function(row) {
        row.classList.remove('is-pinned');
      });

      if (!isOi) {
        faqRow.classList.add('is-pinned');
      }
    });
  });
});

jQuery(document).ready(function() {
  jQuery('.block-content_form_fields_field_buttons_filter').click(function() {
    jQuery('.wp-block-app-articles-filter').toggleClass('show');
  });
});

document.addEventListener('DOMContentLoaded', function() {
  const imageColumns = document.querySelectorAll('.image-column');

  imageColumns.forEach(function(column) {
    const featuredImage = column.querySelector('.wp-block-post-featured-image');

    if (!featuredImage) {
      const newFigure = document.createElement('figure');
      newFigure.classList.add('wp-block-post-featured-image');
      column.appendChild(newFigure);
      column.classList.add('image-column-no-image');
    }
  });
});

jQuery(document).ready(function() {
  jQuery('.cc-tip').each(function() {
      const ccTipInfoDiv = jQuery('<div>').addClass('cc-tip-info');

      const permissionsElement = jQuery('<permissions>');
      const licenseElement = jQuery('<license>').attr({
          'license-type': 'open-access',
          'xlink:href': 'https://creativecommons.org/licenses/by/4.0/',
          'xml:lang': 'en'
      });
      const licensePElement = jQuery('<license-p>').text('This is an Open Access article distributed under the terms of the Creative Commons Attribution License, which permits unrestricted use, distribution, and reproduction in any medium, provided the original work is properly cited.');

      licenseElement.append(licensePElement);
      permissionsElement.append(licenseElement);
      ccTipInfoDiv.append(permissionsElement);

      jQuery(this).append(ccTipInfoDiv);
  });
});

setTimeout(function() {
  const contentWrapper = jQuery('.wp-block-app-read-more .content-wrapper');

  if (contentWrapper.length > 0 && contentWrapper.html().trim() === '') {
    contentWrapper.parent().addClass('hide');
  }
}, 2000);

jQuery(document).ready(function() {
  const tagCloud = jQuery('.wp-block-tag-cloud');

  if (tagCloud.length > 0) {
      const tagLinks = tagCloud.find('.tag-cloud-link');

      // Função para extrair o número entre parênteses
      const extractNumber = function(text) {
          const match = /\((\d+)\)/.exec(text);
          return match ? parseInt(match[1], 10) : 0;
      };

      // Ordenar os tag-links com base no número dentro dos parênteses
      tagLinks.sort(function(a, b) {
          const countA = extractNumber(jQuery(a).find('.tag-link-count').text());
          const countB = extractNumber(jQuery(b).find('.tag-link-count').text());
          return countB - countA;
      });

      // Remover tag-links existentes
      tagLinks.detach();

      // Adicionar tag-links ordenados de volta à .wp-block-tag-cloud
      tagCloud.append(tagLinks);
  }
});
